import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import * as $ from 'jquery';
import { LinkService } from '../../_services/langhfre.service';
//declare function ire(string,{}): any;
@Component({
  selector: 'app-publication-checks',
  templateUrl: './publication-checks.component.html',
  styleUrls: ['./publication-checks.component.scss']
})
export class PublicationChecksComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService
  ) { }

  ngOnInit() {
    this.titleService.setTitle('論文受理の可能性を高める出版適正チェック | Trinka');
    this.metaTagService.updateTag({ name: 'description', content: 'Trinka（トリンカ）の出版適正チェック機能は、ジャーナルとの相性や倫理面のチェックなど20以上のポイントで英語論文を査定。論文受理の可能性を高めます。' });
    this.metaTagService.updateTag({ property: 'og:title', content: '論文受理の可能性を高める出版適正チェック | Trinka' });
    this.metaTagService.updateTag({ property: 'og:description', content: 'Trinka（トリンカ）の出版適正チェック機能は、ジャーナルとの相性や倫理面のチェックなど20以上のポイントで英語論文を査定。論文受理の可能性を高めます。' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/jp/features/publication-readiness-checks' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/features/s3.svg' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: '論文受理の可能性を高める出版適正チェック | Trinka' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "Trinka（トリンカ）の出版適正チェック機能は、ジャーナルとの相性や倫理面のチェックなど20以上のポイントで英語論文を査定。論文受理の可能性を高めます。" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/features/s3.svg' });
    this.metaTagService.updateTag({ name: 'language', content: 'ja-jp' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/jp/features/publication-readiness-checks' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/features/technical-checks' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/features/technical-checks' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/features/publication-readiness-checks' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/features/publication-readiness-checks' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/features/publication-readiness-checks' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/features/publication-readiness-checks' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/features/publication-readiness-checks' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/features/publication-readiness-checks' });
    if (isPlatformBrowser(this.platformId)) {
      // $.getScript('../../../assets/js/particles.min.js', function(){});
      $.getScript('../../../assets/js/wisepop.js', function () { });
    }
    //ire('identify', {'customerId':'', customerEmail: '', customProfileId: this.generateGuid()});
  }
  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }
  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      $('#closedPopup, #wordPluginPopup').click(function () {
        $('iframe.youtubeVideoForTryDemo').remove()
      });

      $('#VewiVideoSection').click(function () {
        if (!$('#iframe').length) {
          $('#iframeHolder').html('<iframe class="youtubeVideoForTryDemo" id="iframe" src="https://www.youtube.com/embed/c8yyiW2tEjE" width="100%" height="450"></iframe>');
        }
      });

    }
  }

  
}
